var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { BatchDeleteEventDto, BatchEditEventDto } from '../../../../../shared/service-proxies/service-proxies';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { TriggerRuleType } from '../shared/enum/trigger-rule-type';
import { EnumChangeValue } from '../shared/enum/enum-change-value';
import { ConditionTypeHelper } from '../shared/condition-type-helper';
import { CreateOrEditEventModalComponent } from './create-or-edit-modal/create-or-edit-event-modal.component';
import { BatchEditEventModalComponent } from './batch-edit-modal/batch-edit-event-modal.component';
import { EventGroupModalComponent } from './event-group-modal/event-group-modal.component';
import { DataType } from '../../../core/variable/data-type';
import { appModuleAnimation } from '../../../animations/routerTransition';
var ConfigureEventComponent = /** @class */ (function (_super) {
    __extends(ConfigureEventComponent, _super);
    function ConfigureEventComponent(injector, configureEventService, configureEventGroupService, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.configureEventService = configureEventService;
        _this.configureEventGroupService = configureEventGroupService;
        _this.modalService = modalService;
        _this.selectedEvents = [];
        return _this;
    }
    Object.defineProperty(ConfigureEventComponent.prototype, "selectedAlarmIds", {
        get: function () {
            if (!this.selectedEvents || this.selectedEvents.length === 0) {
                return [];
            }
            return this.selectedEvents.map(function (x) { return x.id; });
        },
        enumerable: true,
        configurable: true
    });
    ConfigureEventComponent.prototype.ngOnInit = function () {
        this.loadGroups();
    };
    ConfigureEventComponent.prototype.loadConfigureEvents = function (event) {
        var _this = this;
        if (!this.configureId) {
            return;
        }
        this.lazyLoadEvent = event;
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            return;
        }
        if (!this.selectedGroupId) {
            this.selectedGroupId = undefined;
        }
        this.primengTableHelper.showDelayLoadingIndicator();
        this.configureEventService.getEvents(this.configureId, this.selectedGroupId, this.eventNameOrVariableName, this.primengTableHelper.getSorting(this.dataTable), this.primengTableHelper.getMaxResultCount(this.paginator, event), this.primengTableHelper.getSkipCount(this.paginator, event)).pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
            .subscribe(function (result) {
            _this.primengTableHelper.requestCompleted = true;
            _this.primengTableHelper.totalRecordsCount = result.totalCount;
            _this.primengTableHelper.records = result.items;
            if (_this.lazyLoadEvent && result.totalCount && (!result.items || result.items.length === 0)) {
                var jumpToPage = ~~((result.totalCount - 1) / _this.paginator.rows);
                _this.paginator.changePage(jumpToPage);
            }
            _this.primengTableHelper.hideLoadingIndicator();
        });
    };
    ConfigureEventComponent.prototype.formatTriggerRule = function (result) {
        if (!result.triggerRuleType && result.triggerRuleType !== 0) {
            return '';
        }
        switch (+result.triggerRuleType) {
            case TriggerRuleType.Threshold: // 阀值
                if (!result.variableDataType) {
                    return '';
                }
                return this.getTriggerRuleFromVariable(result.triggerRuleValue.threshold, +result.variableDataType);
            case TriggerRuleType.Deviance: // 偏差
                return "" + this.lc('DevianceValue') + result.triggerRuleValue.deviance.value + "," + this.lc('TargetValue') + result.triggerRuleValue.deviance.targetValue;
            case TriggerRuleType.ChangeRate: // 变化率
                return "" + this.lc('ChangeRate') + result.triggerRuleValue.changeRate.changeRate + "," + result.triggerRuleValue.changeRate.cycle + "s";
            case TriggerRuleType.Change: // 值变化
                return this.getChangeValue(+result.triggerRuleValue.value);
            default:
                return '';
        }
    };
    ConfigureEventComponent.prototype.getChangeValue = function (value) {
        switch (+value) {
            case EnumChangeValue.Value0:
                return this.lc('Value0');
            case EnumChangeValue.Value1:
                return this.lc('Value1');
            case EnumChangeValue.Change:
                return this.lc('ValueChange');
            default:
                return '';
        }
    };
    ConfigureEventComponent.prototype.getTriggerRuleFromVariable = function (threshold, dataType) {
        return this.getTriggerRule({
            dataType: dataType,
            operand1: threshold.operand1,
            operand2: threshold.operand2,
            conditionCombineMethod: threshold.conditionCombine,
            condition1: threshold.condition1,
            condition2: threshold.condition2
        });
    };
    ConfigureEventComponent.prototype.getTriggerRule = function (triggerRule) {
        var isBit = false;
        if (triggerRule.dataType === DataType.Bool) {
            isBit = true;
        }
        if (isBit && triggerRule.operand1 === 0) {
            return 'OFF';
        }
        if (isBit && triggerRule.operand1 === 1) {
            return 'ON';
        }
        if (!isBit) {
            switch (triggerRule.conditionCombineMethod) {
                case 0:
                    return this.lc('Value') + ' ' + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition1)) + triggerRule.operand1;
                case 1:
                    return this.lc('Value') + ' ' + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition1)) +
                        triggerRule.operand1 + this.lc('And') + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition2)) + triggerRule.operand2;
                case 2:
                    return this.lc('Value') + ' ' + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition1)) +
                        triggerRule.operand1 + this.lc('Or') + this.lc(ConditionTypeHelper.getAlarmConditionName(triggerRule.condition2)) + triggerRule.operand2;
            }
        }
    };
    ConfigureEventComponent.prototype.createOrUpdateEvent = function (eventId) {
        var _this = this;
        var modalRef = this.modalService.show(CreateOrEditEventModalComponent, {
            initialState: {
                configureId: this.configureId,
                eventId: eventId
            },
            class: 'create-or-edit-event-modal',
            backdrop: 'static'
        });
        modalRef.content.createdEvent.subscribe(function () {
            _this.loadConfigureEvents();
        });
        modalRef.content.updatedEvent.subscribe(function () {
            _this.loadEventsDataOnCurrentPage();
        });
    };
    ConfigureEventComponent.prototype.batchEditEvents = function () {
        var _this = this;
        var eventIds = this.selectedEvents.map(function (x) { return x.id; });
        var batchEditEventDto = new BatchEditEventDto();
        batchEditEventDto.configureId = +this.configureId;
        batchEditEventDto.eventIds = eventIds;
        var modalRef = this.modalService.show(BatchEditEventModalComponent, {
            initialState: {
                configureId: this.configureId,
                batchEditEventDto: batchEditEventDto
            },
            backdrop: 'static'
        });
        modalRef.content.batchEditedEvent.subscribe(function () {
            _this.loadEventsDataOnCurrentPage();
        });
    };
    ConfigureEventComponent.prototype.loadEventsDataOnCurrentPage = function () {
        this.loadConfigureEvents(this.lazyLoadEvent);
    };
    ConfigureEventComponent.prototype.singleDeleteEvent = function (id) {
        var _this = this;
        this.message.confirm(this.lc('EventDeleteWarningMessage'), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                _this.primengTableHelper.showDelayLoadingIndicator();
                _this.configureEventService.deleteEvent(_this.configureId, id)
                    .pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
                    .subscribe(function () {
                    _this.selectedEvents = _this.selectedEvents.filter(function (alarm) { return alarm.id !== id; });
                    // 删除成功提示
                    _this.primengTableHelper.hideLoadingIndicator();
                    abp.notify.success(_this.l('SuccessfullyDeleted'));
                    _this.loadConfigureEvents(_this.lazyLoadEvent);
                });
            }
        });
    };
    ConfigureEventComponent.prototype.batchDeleteEvents = function () {
        var _this = this;
        this.message.confirm(this.lc('AlarmDeleteWarningMessage'), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                _this.primengTableHelper.showDelayLoadingIndicator();
                var batchDeleteEventDto = new BatchDeleteEventDto();
                batchDeleteEventDto.configureId = _this.configureId;
                batchDeleteEventDto.eventIds = _this.selectedAlarmIds;
                _this.configureEventService.batchDeleteEvent(batchDeleteEventDto)
                    .pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
                    .subscribe(function () {
                    // 删除成功提示
                    _this.primengTableHelper.hideLoadingIndicator();
                    abp.notify.success(_this.l('SuccessfullyDeleted'));
                    _this.selectedEvents = [];
                    _this.loadConfigureEvents();
                });
            }
        });
    };
    ConfigureEventComponent.prototype.loadGroups = function () {
        var _this = this;
        this.configureEventGroupService.getEventGroups(this.configureId)
            .subscribe(function (result) {
            _this.groupList = result;
        });
    };
    ConfigureEventComponent.prototype.loadEventAndClearSelectedItems = function () {
        this.selectedEvents = [];
        this.loadConfigureEvents();
    };
    ConfigureEventComponent.prototype.loadEventAndGroup = function (deletedIds) {
        if (this.selectedEvents && deletedIds.length > 0) {
            this.selectedEvents = this.selectedEvents.filter(function (x) { return deletedIds.findIndex(function (id) { return id === x.id; }) === -1; });
        }
        this.loadGroups();
        this.loadConfigureEvents();
    };
    ConfigureEventComponent.prototype.showEventGroupModal = function () {
        var _this = this;
        var modalRef = this.modalService.show(EventGroupModalComponent, {
            initialState: {
                configureId: this.configureId
            },
            backdrop: 'static'
        });
        modalRef.content.groupSavedEvent.subscribe(function () {
            _this.loadGroups();
        });
        modalRef.content.groupEditedEvent.subscribe(function () {
            _this.loadEventsAndGroupOnCurrentPage();
        });
        modalRef.content.groupDeletedEvent.subscribe(function (result) {
            _this.loadEventAndGroup(result);
        });
    };
    ConfigureEventComponent.prototype.loadEventsAndGroupOnCurrentPage = function () {
        this.loadGroups();
        this.loadConfigureEvents(this.lazyLoadEvent);
    };
    __decorate([
        Input()
    ], ConfigureEventComponent.prototype, "configureId", void 0);
    __decorate([
        ViewChild('dataTable', { static: true })
    ], ConfigureEventComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('paginator', { static: false })
    ], ConfigureEventComponent.prototype, "paginator", void 0);
    ConfigureEventComponent = __decorate([
        Component({
            selector: 'configure-event',
            template: "<div class=\"portlet-input designer-configure-event\"> <div class=\"row configure-event-operation\"> <div class=\"col-12 operation-filter\"> <div class=\"col-lg-2 operation-filter-select\"> <ng-select name=\"groupSelect\" [items]=\"groupList\" bindLabel=\"name\" bindValue=\"id\" [searchable]=\"true\" [placeholder]=\"lc('AllEventGroup')\" [(ngModel)]=\"selectedGroupId\" [clearable]=\"true\" (change)=\"loadEventAndClearSelectedItems()\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{item.name}} </ng-template> </ng-select> </div> </div> </div> <div class=\"row configure-event-operation\"> <div class=\"col-lg-6 operation-button\"> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"createOrUpdateEvent()\">{{lc('AddEvent')}}</button> <button class=\"fe-btn fe-btn-default btn-batch-delete\" [disabled]=\"!selectedEvents || selectedEvents.length === 0\" (click)=\"batchEditEvents()\">{{lc('BatchEdit')}}</button> <button class=\"fe-btn fe-btn-default btn-batch-delete\" [disabled]=\"!selectedEvents || selectedEvents.length === 0\" (click)=\"batchDeleteEvents()\">{{lc('BatchDelete')}}</button> <button class=\"fe-btn fe-btn-default fe-btn-normal\" (click)=\"showEventGroupModal()\">{{lc('EventGroupManage')}}</button> </div> <div class=\"col-lg-6 operation-filter\"> <div class=\"operation-search\"> <input class=\"operation-search-input\" placeholder='{{lc(\"EventSearchCriteria\")}}' type=\"text\" name=\"eventNameOrVariableName\" (change)=\"loadEventAndClearSelectedItems()\" [(ngModel)]=\"eventNameOrVariableName\"> <i class=\"fcloud-search\"></i> </div> </div> </div> </div> <div class=\"primeng-datatable-container designer-actions-style\" [busyIf]=\"primengTableHelper.isLoading\"> <p-table #dataTable (onLazyLoad)=\"loadConfigureEvents($event)\" [value]=\"primengTableHelper.records\" rows=\"{{primengTableHelper.defaultRecordsCountPerPage}}\" [paginator]=\"false\" [lazy]=\"true\" selectionMode=\"multiple\" [(selection)]=\"selectedEvents\" scrollable=\"true\" dataKey=\"id\" ScrollWidth=\"100%\" responsive=\"primengTableHelper.isResponsive\" resizableColumns=\"primengTableHelper.resizableColumns\"> <ng-template pTemplate=\"header\"> <tr> <th class=\"checkbox\" style=\"width: 50px;\"> <p-tableHeaderCheckbox></p-tableHeaderCheckbox> </th> <th style=\"width: 100px\"> {{lc('EventName')}} </th> <th style=\"width: 150px\"> {{lc('EventMessage')}} </th> <th style=\"width: 100px\"> {{lc('EventDataSource')}} </th> <th style=\"width: 100px\"> {{lc('EventGroup')}} </th> <th style=\"width: 200px\"> {{lc('TriggerRule')}} </th> <th style=\"width: 100px\"> {{lc('ConfigureVariableName')}} </th> <th style=\"width: 100px\" class=\"last-th\"> {{l('Actions')}} <span class=\"fa fa-cog fa-fw\"></span> </th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-record> <tr [pSelectableRow]=\"record\"> <td class=\"checkbox\" style=\"width: 50px;\"> <p-tableCheckbox [value]=\"record\"></p-tableCheckbox> </td> <td style=\"width: 100px\"> {{record.name}} </td> <td style=\"width: 150px\"> {{record.eventMessage}} </td> <td style=\"width: 100px\"> {{lc('Variable')}} </td> <td style=\"width: 100px\"> {{record.groupName}} </td> <td style=\"width: 200px\"> {{formatTriggerRule(record)}} </td> <td style=\"width: 100px\"> {{record.variableName}} </td> <td style=\"width: 100px\" class=\"operation\"> <a (click)=\"createOrUpdateEvent(record.id)\" style=\"padding-left: 10px\">{{l('Edit')}}</a> <a (click)=\"singleDeleteEvent(record.id)\" style=\"padding-left: 10px\">{{l('Delete')}}</a> </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"primengTableHelper.totalRecordsCount == 0\"> {{l('NoData')}} </div> <div class=\"primeng-paging-container\"> <p-paginator [rows]=\"primengTableHelper.defaultRecordsCountPerPage\" #paginator (onPageChange)=\"loadConfigureEvents($event)\" [totalRecords]=\"primengTableHelper.totalRecordsCount\" [rowsPerPageOptions]=\"primengTableHelper.predefinedRecordsCountPerPage\"> </p-paginator> <span class=\"total-records-count\"> {{l('TotalRecordsCount', primengTableHelper.totalRecordsCount)}} </span> </div> </div> ",
            styles: [" .designer-configure-event{ .last-th { text-align: right !important; span { padding-right: 10px; } } .alarm-search { margin-bottom: 10px; } .input-group { .form-control { padding-right: 16px; } .var-form-control { height: 34px; padding: 0 2rem 0 1.25rem; } .form-control-search { position: absolute; z-index: 4; right: 10px; display: block; width: 16px; height: 16px; line-height: 34px; text-align: center; pointer-events: none; color: #aaa; } } .operation { text-align: right !important; a { color: #3695FF !important; } a:hover { cursor: pointer; } a:first-child { margin-right: 10px; } } .configure-event-operation { .operation-filter-select { padding: 0; } .operation-button { padding: 0; button { margin-bottom: 12px; } } .operation-search { float: right; position: relative; width:285px; input::-webkit-input-placeholder { color: rgba(0, 0, 0, 0.6); } input::-moz-placeholder { /* Mozilla Firefox 19+ */ color: rgba(0, 0, 0, 0.6); } input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ color: rgba(0, 0, 0, 0.6); } input:-ms-input-placeholder { /* Internet Explorer 10-11 */ color: rgba(0, 0, 0, 0.6); } } .fcloud-search { position: absolute; right: 10px; top: 9px; font-size: 16px; cursor: pointer; } .operation-search-input { width: 100%; height: 34px; border: 1px solid #C4C6CF; color: rgba(0, 0, 0, 0.6); line-height: 34px; padding: 0 10px; margin-bottom: 12px; padding-left: 10px; padding-right: 34px; } .operation-filter { padding: 0; .operation-filter-select { float: left; margin-right: 12px; margin-bottom: 12px; } } .fe-btn:not(:last-child) { margin-right: 12px; } } select option { color: rgba(0, 0, 0, 0.6); } .fe-btn.fe-btn-default.btn-batch-delete { color: #000; background-color: #FFF; border: 1px solid #C4C6CF; } .fe-btn.fe-btn-default.fe-btn-normal { border: 1px solid #b5c2ca; background-color: white; } .fe-btn.fe-btn-default.btn-batch-delete:disabled { color: #7F939F; border: 1px solid #b5c2ca; } .configure-event-operation > div { float: left; } .configure-event-operation { margin-left: 0; margin-right: 0; } @media (max-width: 1425px) { .configure-event-operation { .operation-button, .operation-filter { width: 100%; } } } .operation-filter-select ::ng-deep .ng-select-container { height: 34px !important; border: 1px solid #C4C6CF; } .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input { top: 0px !important; } }"],
            animations: [appModuleAnimation()]
        })
    ], ConfigureEventComponent);
    return ConfigureEventComponent;
}(ConfigureComponentBase));
export { ConfigureEventComponent };
